import Serializable from "@/core/misc/mixins/Serializable";

class PartnerRoleAccess extends Serializable {

    public seller: boolean;
    public buyer: boolean;

}

export default PartnerRoleAccess;